/* remove params from url - modal forms reload*/
function removeUrlParams() {
  
  const queryString = window.location.search;
  //const currentUrl = window.location.href;
  
  if(queryString) {
    // remove modal params from url, keep list
    const urlParams = new URLSearchParams(queryString);
    const listValue = urlParams.get('view');
    const pageValue = urlParams.get('page');
    // nur auf übersichtsseiten - nicht im einsatz
    if (!pageValue) {
      window.history.replaceState(null, null, '?view='+listValue);
    }
    //urlParams.delete('modal');
    
    //const urlObj = new URL(currentUrl);
    //urlObj.search = '';
    //const result = urlObj.toString();
    //window.history.pushState(stateObj, '', '');
  }
}

export {removeUrlParams};